module.exports = __webpack_public_path__ + "static/media/img1.7c2184cb.jpeg";